import axios from "../../../config/axiosConfig";

export const buscarCentroEquipos = (params = {}) =>
  axios.get("/api/centro-equipos/buscar", { params });

export const listarCentroEquipos = (params = {}) =>
  axios.get("/api/centro-equipos/listado", { params });

export const exportarListadoCentroEquiposExcel = (params = {}) =>
  axios.get("/api/centro-equipos/listado/exportar-excel", { params, responseType: "blob" });

export const cambiarEstadoModemCentro = (numSim, estado, observacion = "") =>
  axios.put(`/api/centro-equipos/modems/${encodeURIComponent(numSim)}/estado`, { estado, observacion });

// `id` va en el body (no en la URL): algunas series/identificadores traen "/",
// y ciertos proxies delante del backend decodifican %2F antes de que llegue a
// Express, rompiendo el matching de la ruta. Ver tambien getCentroEquipoDetalle.
export const cambiarEstadoEquipoCentro = (tipo, id, estado, observacion = "") =>
  axios.put(`/api/centro-equipos/${encodeURIComponent(tipo)}/estado`, { id, estado, observacion });

export const actualizarObservacionEquipoCentro = (tipo, id, observacion = "") =>
  axios.put(`/api/centro-equipos/${encodeURIComponent(tipo)}/observacion`, { id, observacion });

export const actualizarDatosEquipoCentro = (tipo, id, datos = {}) =>
  axios.put(`/api/centro-equipos/${encodeURIComponent(tipo)}/datos`, { id, ...datos });

// Cambia el modelo eligiendo tipo de modelo y modelo del catálogo (body: { id_tipo_modelo, id_modelo, marca? })
export const cambiarModeloEquipoCentro = (tipo, id, body = {}) =>
  axios.put(`/api/centro-equipos/${encodeURIComponent(tipo)}/modelo`, { id, ...body });

export const actualizarPlacaModemCentro = (numSim, placa) =>
  axios.put(`/api/centro-equipos/modems/${encodeURIComponent(numSim)}/placa`, { placa });

export const reasignarVehiculoModemCentro = (numSim, placa) =>
  axios.put(`/api/centro-equipos/modems/${encodeURIComponent(numSim)}/reasignar-vehiculo`, { placa });

export const crearTraspasoCentroEquipos = (body = {}) =>
  axios.post("/api/centro-equipos/traspaso", body);

export const listarTraspasosCentroEquipos = (params = {}) =>
  axios.get("/api/centro-equipos/traspasos", { params });

export const getTraspasoCentroEquipos = (id) =>
  axios.get(`/api/centro-equipos/traspasos/${encodeURIComponent(id)}`);

export const getTraspasoPdfCentroEquipos = (id) =>
  axios.get(`/api/centro-equipos/traspasos/${encodeURIComponent(id)}/pdf`, {
    responseType: "blob",
  });

export const getCentroEquipoDetalle = (tipo, id) =>
  axios.get(`/api/centro-equipos/${encodeURIComponent(tipo)}/historial`, { params: { id } });

export const getResumenServicios = () =>
  axios.get("/api/centro-equipos/resumen/servicios");

export const getResumenEquipos = (relacion) =>
  axios.get("/api/centro-equipos/resumen/equipos", { params: { relacion } });

export const getResumenModelos = (detalle) =>
  axios.get("/api/centro-equipos/resumen/modelos", { params: { detalle } });

export const getResumenEquiposData = (params = {}) =>
  axios.get("/api/centro-equipos/resumen", { params });

export const getResumenEquiposDetalle = (params = {}) =>
  axios.get("/api/centro-equipos/resumen/detalle", { params });

export const exportarResumenEquiposDetalleExcel = (params = {}) =>
  axios.get("/api/centro-equipos/resumen/detalle/exportar-excel", { params, responseType: "blob" });

export const listarComandosSms = (params = {}) =>
  axios.get("/api/sms/comandos", { params });

export const enviarSmsSinReporte = (body = {}) =>
  axios.post("/api/sin-reporte", body);

export const listarSmsEnviados = (params = {}) =>
  axios.get("/api/sms", { params });

// Accesorios con stock en la sucursal origen (traspaso por cantidad).
export const listarAccesoriosTraspasoCentroEquipos = (params = {}) =>
  axios.get("/api/centro-equipos/traspaso/accesorios", { params });

export const consultaMasivaChips = (identificadores) =>
  axios.post("/api/centro-equipos/chips/consulta-masiva", { identificadores });
